module.exports = __webpack_public_path__ + "img/nav-notification.00e334b2.svg";